<template>
  <Switcher
    ref="switcher"
    :onShow="onShow"
    :onClose="onClose"
    :render="render"
  >
    <div class="modal" @click.stop>
      <slot />
    </div>
  </Switcher>
</template>

<script>
  import { eventBus, EVENTS }     from "../event_bus";
  import Switcher                 from "./switcher.vue";

  export default {
    name: "Modal",
    components: {
      Switcher
    },
    props: {
      render: Boolean,
      onShow: Function,
      onClose: Function,
    },
    methods: {
      show() {
        this.$refs.switcher.show();
        eventBus.$on(EVENTS.Body.Click, this.onBodyClick);
      },
      close() {
        this.$refs.switcher.close();
        eventBus.$off(EVENTS.Body.Click, this.onBodyClick);
      },
      turn() {
        this.$refs.switcher.isDisplayed ? this.close() : this.show();
      },
      onBodyClick() {
        this.close();
      },
    },
  }
</script>
